export enum ReportingActionType {
  FETCH_POWER_BI_ACCESS_DETAILS = 'FETCH_POWER_BI_ACCESS_DETAILS',
  FETCH_POWER_BI_CONTRACTS_ACCESS_DETAILS = 'FETCH_POWER_BI_CONTRACTS_ACCESS_DETAILS',
  FETCH_REPORTS = 'FETCH_REPORTS'
}
